import { buildRequestURL, getRESTParams, WP_API_URL } from '.'

const ERR_CODE_JWT_OBSOLETE = 'jwt_auth_obsolete_token'
const ERR_JWT_OBSOLETE =
  'Your authorization token has expired. Please logout and login again.'

/* =============================================
 * Private helpers
 * ============================================= */
/**
 * Support GET request pattern wrapper.
 * @param {Object} params Parameter object to merge with common params.
 * See getRESTParams method for more info.
 */

const _articleRESTGET = async (url, queryObj, paramObj) => {
  const requestUrl = buildRequestURL(url, queryObj)
  const params = getRESTParams(paramObj)
  const result = await fetch(requestUrl, params)
    .then(response => response.json())
    .catch(error => {
      console.error('error', error)
    })

  // JWT expired
  if (result?.code === ERR_CODE_JWT_OBSOLETE) throw new Error(ERR_JWT_OBSOLETE)

  return result
}

/* =============================================
 * Public helpers
 * ============================================= */

/**
 * Retrieves the Remble Articles from the WP API using Remble's Python proxy or an empty list if no articles are found.
 */
const getRembleArticles = async () => {
  const url = `${WP_API_URL}/posts`
  const articles = await _articleRESTGET(
    url,
    { per_page: 100, orderby: 'date' }
  )

  return articles
}

/**
 * Retrieves the Remble Articles from WP api using Remble's python API by id.
 */
const getRembleArticlesByID = async id => {
  const url = `${WP_API_URL}/posts/${id}`
  const article = await _articleRESTGET(url)

  return article
}

export { getRembleArticles, getRembleArticlesByID }
